import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'consent-templates',
    meta: {
      breadcrumb: {
        key: 'consentTemplate.entity',
        plural: 2
      }
    },
    children: [
      {
        path: '',
        name: 'consentTemplates.index',
        component: () => import('@/modules/consent-templates/views/ConsentTemplatesIndex.vue')
      },
      {
        path: ':consentTemplateId/versions/:versionNumber',
        name: 'consentTemplateVersions.show',
        component: () => import('@/modules/consent-templates/views/ConsentTemplateVersionShow.vue'),
        props: (route) => ({
          consentTemplateId: route.params.consentTemplateId,
          versionNumber: Number(route.params.versionNumber)
        })
      },
      {
        path: ':consentTemplateId/versions/:versionNumber/edit',
        component: () =>
          import('@/modules/consent-templates/views/ConsentTemplateVersionUpdate.vue'),
        redirect: { name: 'consentTemplateVersions.update' },
        props: (route) => ({
          consentTemplateId: route.params.consentTemplateId,
          versionNumber: Number(route.params.versionNumber)
        }),
        children: [
          {
            path: 'content',
            name: 'consentTemplateVersions.update',
            component: () =>
              import('@/modules/consent-templates/views/ConsentTemplateVersionContent.vue')
          },
          {
            path: 'translations',
            name: 'consentTemplateVersions.translations',
            component: () =>
              import('@/modules/consent-templates/views/ConsentTemplateVersionTranslations.vue')
          }
        ]
      }
    ]
  }
]

export default routes
